module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Confirmation Dialog","defaultConfirmationText":"Please confirm your action to continue.","accept":"Yes","decline":"Cancel"},"es":{"title":"Diálogo de confirmación","defaultConfirmationText":"Por favor, confirme su acción para continuar.","accept":"Acepto","decline":"No Acepto"}}')
  delete Component.options._Ctor
}
